<template>
    <v-app>
        <v-card width="400" class="mx-auto mt-5">
            <v-alert type="error" v-if="errors"><template v-for="error in errors"> {{ error }}</template></v-alert>
            <v-form @submit.prevent="login">
            <v-card-title>Login</v-card-title>
            <v-card-text>
                    <!-- <v-text-field label="Username" prepend-icon="mdi-account-circle" :rules="[rules.required]" v-model="userName"/> -->
                    <v-text-field label="Email" prepend-icon="mdi-email" :rules="[rules.required, rules.email]" v-model="email" />
                    <v-text-field label="6 digit code" prepend-icon="mdi-two-factor-authentication" :rules="[rules.required]" v-model="twoFactorCode" />
            </v-card-text>
            <v-card-actions>
                <v-btn color="info" type="submit" block>Login</v-btn>
            </v-card-actions>
            </v-form>
        </v-card>
    </v-app>
</template>

<script>

export default {
    name: "Login",
    data: () => ({
        showPassword: false,
        rules: {
          required: value => !!value || 'Required.',
          counter: value => value.length <= 20 || 'Max 20 characters',
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Invalid e-mail.'
          },
        },
        twoFactorCode: "",
        userName: "",
        email: "",
        errors: null

    }),
    methods: {
        login(){ 
            this.$store.dispatch('retriveToken',{
                twoFactorCode: this.twoFactorCode,
                userName: this.userName,
                email: this.email
            })
            .then(() => { 
                this.$router.push({ name: 'dashboard' });
            }).catch((error)=>{
                this.errors = error.response.data
            });
            //alert(this.userName);
        }
    }
}
</script>